module.exports = __webpack_public_path__ + "img/3.58825ff9.webp";